module.exports = __webpack_public_path__ + "img/CL.174eee37.svg";